import React from "react";
import GameBoardTemplate from "../components/GameBoardTemplate";

export default function GameStart() {
  return (
    <>
      <GameBoardTemplate />
    </>
  );
}
